import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const AuditorConfidentiality = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Auditor Confidentiality</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) emphasizes auditor confidentiality under its Industrial Research and Training division to ensure trust, integrity, and impartiality in auditing processes.
          </p>
          <p className="subtitle">
            Confidentiality protects sensitive organizational information and maintains professional standards during audits and certification activities.
          </p>
        </div>
      </section>

      {/* === Key Principles Section === */}
      <section className="intro-section">
        <h2 className="section-title">Key Principles of Auditor Confidentiality</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Auditors must safeguard all information obtained during audits</li>
              <li>Information must not be disclosed to unauthorized parties</li>
              <li>Confidentiality applies to both electronic and physical documents</li>
              <li>Auditors must avoid conflicts of interest that could compromise confidentiality</li>
              <li>All findings and recommendations are handled discreetly</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Confidentiality extends to client data, processes, and proprietary information</li>
              <li>Auditors must follow MBS policies and international standards for confidentiality</li>
              <li>Unauthorized disclosure may result in disciplinary action</li>
              <li>Maintaining confidentiality strengthens trust between auditors and organizations</li>
              <li>Auditors are responsible for secure storage and transmission of audit reports</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Benefits Section === */}
      <section className="functions-section">
        <h2 className="section-title">Benefits of Auditor Confidentiality</h2>
        <p>
          Upholding confidentiality ensures organizations feel secure during audits, enhances the credibility of audit findings, promotes impartiality, and protects both the auditor and the client from potential conflicts or misuse of sensitive information.
        </p>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for Auditor Guidance</h2>
        <p>
          For inquiries, guidance, or training related to auditor confidentiality, please contact the Industrial Research and Training team at MBS.
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:training@mbs.mw">training@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 888</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Office: Malawi Bureau of Standards, P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
        <p className="subtitle">
          Auditor confidentiality strengthens trust, maintains professional integrity, and ensures that MBS audits and certification activities are conducted ethically and securely.
        </p>
      </section>

      <br /><br />
    </div>
  );
};

export default AuditorConfidentiality;
